import qoalaStorage from '~/core/Storage';

export default () => ({
  policyList: [],
  claimList: {},
  documentsType: qoalaStorage.getItem('documentsType'),
  OTAList: qoalaStorage.getItem('OTAList')
});
